export var toGQLLocale = function (locale) {
    return locale.slice(0, 5);
};
export var getFormDataBody = function (query, variables, assocMap) {
    var map = {};
    var body = new FormData();
    body.append('operations', JSON.stringify({ query: query, variables: variables }));
    assocMap.forEach(function (_a, key) {
        var name = _a.name, value = _a.value;
        map[name] = ["variables." + key];
        body.append(name, value);
    });
    body.append('map', JSON.stringify(map));
    return body;
};
export var toGQLUrlParams = function (query) {
    return query.startsWith('?') ? query.slice(1) : query;
};
